(() => {
  const noticeSelector = '[data-sky-cold-cup-print-notice]';
  const singleColorPattern = /single\s*color|\b1\s*[-–]?\s*color\b/i;

  const getSelectedPrintValue = (productInfo) => {
    const selectedRadio = productInfo.querySelector('variant-selects input[name^="Print-"]:checked');
    if (selectedRadio) return selectedRadio.value;

    const selectedDropdown = productInfo.querySelector('variant-selects select[name="options[Print]"]');
    return selectedDropdown?.value || '';
  };

  const syncNotices = (scope = document) => {
    scope.querySelectorAll(noticeSelector).forEach((notice) => {
      const productInfo = notice.closest('product-info');
      const quantityInput = productInfo?.querySelector('.quantity__input');
      const quantity = Number(quantityInput?.value) || 0;
      const isSingleColor = singleColorPattern.test(getSelectedPrintValue(productInfo));

      notice.hidden = !(isSingleColor && quantity > 0 && quantity < 3000);
    });
  };

  const syncClosestNotice = (target) => {
    const productInfo = target.closest?.('product-info');
    if (productInfo) syncNotices(productInfo);
  };

  document.addEventListener('input', (event) => {
    if (event.target.matches('.quantity__input')) syncClosestNotice(event.target);
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('.quantity__input, variant-selects input, variant-selects select')) {
      window.setTimeout(() => syncClosestNotice(event.target), 0);
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const productInfo = document.getElementById(`MainProduct-${event?.data?.sectionId}`);
      if (productInfo) syncNotices(productInfo);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncNotices(), { once: true });
  } else {
    syncNotices();
  }
})();
